import { store } from "@/store/store";
import { setUser } from "@/store/user";
import axios, { AxiosRequestConfig } from "axios";

const BASE_URL = import.meta.env.VITE_API_BASE_URL; // Access the base URL

export const getAccessToken = () => localStorage.getItem("are@accessToken");
export const saveAccessToken = (token: string) =>
    localStorage.setItem("are@accessToken", token);
export const removeAccessToken = () =>
    localStorage.removeItem("are@accessToken");

// Function to refresh the access token
export const refreshToken = async () => {
    const res = await axios.get(`${BASE_URL}/refresh`, {
        withCredentials: true, // include cookies
    });

    store.dispatch(setUser(res.data.user));

    const newAccessToken = res.data.access_token;
    saveAccessToken(newAccessToken); // Save new token in localStorage
    return newAccessToken;
};

// General function to handle Axios requests with 401 and token refresh logic
export const apiClientWithRefreshToken = async (config: AxiosRequestConfig) => {
    try {
        // Make the original request with the current token
        const accessToken = getAccessToken();
        const response = await axios({
            ...config,
            url: `${BASE_URL}${config.url}`, // Prepend base URL
            headers: {
                ...config.headers,
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return response;
    } catch (err: any) {
        if (err.response && err.response.status === 401) {
            // Token is invalid, attempt to refresh it
            try {
                const newAccessToken = await refreshToken();
                // Retry the original request with the new token
                const retryResponse = await axios({
                    ...config,
                    url: `${BASE_URL}${config.url}`, // Prepend base URL
                    headers: {
                        ...config.headers,
                        Authorization: `Bearer ${newAccessToken}`,
                    },
                });
                return retryResponse;
            } catch (refreshError) {
                // Handle token refresh failure
                removeAccessToken();
                window.location.href = "/login";
                throw refreshError;
            }
        }
        // Throw other errors
        throw err;
    }
};

export const apiClient = async (config: AxiosRequestConfig) => {
    const response = await axios({
        ...config,
        url: `${BASE_URL}${config.url}`,
    });
    return response;
};
